<script lang="ts">
  import {Delete,  href} from "../../../utils/Constant/Constant";
  import Link from "svelte-link";
  import {personalData} from "../../../store"
  export let getId:number
  let setPersonalData:any
  personalData.subscribe((value)=>{
      setPersonalData = value
  })
  const handleRemove = (id:number) => {
    personalData.update(value => value = setPersonalData.filter((data:any, index:number)=> index != id))
  }
</script>
<li>
    <Link href={href} on:click={()=>handleRemove(getId)}>{Delete}</Link>
</li>